/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LineItemMatchGroupWithItems } from './LineItemMatchGroupWithItems';
import {
    LineItemMatchGroupWithItemsFromJSON,
    LineItemMatchGroupWithItemsFromJSONTyped,
    LineItemMatchGroupWithItemsToJSON,
    LineItemMatchGroupWithItemsToJSONTyped,
} from './LineItemMatchGroupWithItems';
import type { RoomMatchGroupWithItems } from './RoomMatchGroupWithItems';
import {
    RoomMatchGroupWithItemsFromJSON,
    RoomMatchGroupWithItemsFromJSONTyped,
    RoomMatchGroupWithItemsToJSON,
    RoomMatchGroupWithItemsToJSONTyped,
} from './RoomMatchGroupWithItems';
import type { Comparison } from './Comparison';
import {
    ComparisonFromJSON,
    ComparisonFromJSONTyped,
    ComparisonToJSON,
    ComparisonToJSONTyped,
} from './Comparison';
import type { RoomDetail } from './RoomDetail';
import {
    RoomDetailFromJSON,
    RoomDetailFromJSONTyped,
    RoomDetailToJSON,
    RoomDetailToJSONTyped,
} from './RoomDetail';
import type { LineItemWithMatchInfo } from './LineItemWithMatchInfo';
import {
    LineItemWithMatchInfoFromJSON,
    LineItemWithMatchInfoFromJSONTyped,
    LineItemWithMatchInfoToJSON,
    LineItemWithMatchInfoToJSONTyped,
} from './LineItemWithMatchInfo';

/**
 * Flat, normalized structure optimized for UI operations.
 * Use this for:
 * - Moving line items between rooms
 * - Creating/editing match groups
 * - Filtering unmatched items
 * - Any UI that needs to manipulate matches
 * 
 * @export
 * @interface ComparisonFullDetails
 */
export interface ComparisonFullDetails {
    /**
     * 
     * @type {Comparison}
     * @memberof ComparisonFullDetails
     */
    comparison: Comparison;
    /**
     * All rooms from the insurer estimate (flat array)
     * @type {Array<RoomDetail>}
     * @memberof ComparisonFullDetails
     */
    insurerRooms: Array<RoomDetail>;
    /**
     * All rooms from the contractor estimate (flat array)
     * @type {Array<RoomDetail>}
     * @memberof ComparisonFullDetails
     */
    contractorRooms: Array<RoomDetail>;
    /**
     * All line items from the insurer estimate with embedded match status
     * @type {Array<LineItemWithMatchInfo>}
     * @memberof ComparisonFullDetails
     */
    insurerLineItems: Array<LineItemWithMatchInfo>;
    /**
     * All line items from the contractor estimate with embedded match status
     * @type {Array<LineItemWithMatchInfo>}
     * @memberof ComparisonFullDetails
     */
    contractorLineItems: Array<LineItemWithMatchInfo>;
    /**
     * Room match groups (IDs only, not full details)
     * @type {Array<RoomMatchGroupWithItems>}
     * @memberof ComparisonFullDetails
     */
    roomMatchGroups: Array<RoomMatchGroupWithItems>;
    /**
     * Line item match groups (IDs only, not full details)
     * @type {Array<LineItemMatchGroupWithItems>}
     * @memberof ComparisonFullDetails
     */
    lineItemMatchGroups: Array<LineItemMatchGroupWithItems>;
}

/**
 * Check if a given object implements the ComparisonFullDetails interface.
 */
export function instanceOfComparisonFullDetails(value: object): value is ComparisonFullDetails {
    if (!('comparison' in value) || value['comparison'] === undefined) return false;
    if (!('insurerRooms' in value) || value['insurerRooms'] === undefined) return false;
    if (!('contractorRooms' in value) || value['contractorRooms'] === undefined) return false;
    if (!('insurerLineItems' in value) || value['insurerLineItems'] === undefined) return false;
    if (!('contractorLineItems' in value) || value['contractorLineItems'] === undefined) return false;
    if (!('roomMatchGroups' in value) || value['roomMatchGroups'] === undefined) return false;
    if (!('lineItemMatchGroups' in value) || value['lineItemMatchGroups'] === undefined) return false;
    return true;
}

export function ComparisonFullDetailsFromJSON(json: any): ComparisonFullDetails {
    return ComparisonFullDetailsFromJSONTyped(json, false);
}

export function ComparisonFullDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComparisonFullDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'comparison': ComparisonFromJSON(json['comparison']),
        'insurerRooms': ((json['insurerRooms'] as Array<any>).map(RoomDetailFromJSON)),
        'contractorRooms': ((json['contractorRooms'] as Array<any>).map(RoomDetailFromJSON)),
        'insurerLineItems': ((json['insurerLineItems'] as Array<any>).map(LineItemWithMatchInfoFromJSON)),
        'contractorLineItems': ((json['contractorLineItems'] as Array<any>).map(LineItemWithMatchInfoFromJSON)),
        'roomMatchGroups': ((json['roomMatchGroups'] as Array<any>).map(RoomMatchGroupWithItemsFromJSON)),
        'lineItemMatchGroups': ((json['lineItemMatchGroups'] as Array<any>).map(LineItemMatchGroupWithItemsFromJSON)),
    };
}

export function ComparisonFullDetailsToJSON(json: any): ComparisonFullDetails {
    return ComparisonFullDetailsToJSONTyped(json, false);
}

export function ComparisonFullDetailsToJSONTyped(value?: ComparisonFullDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comparison': ComparisonToJSON(value['comparison']),
        'insurerRooms': ((value['insurerRooms'] as Array<any>).map(RoomDetailToJSON)),
        'contractorRooms': ((value['contractorRooms'] as Array<any>).map(RoomDetailToJSON)),
        'insurerLineItems': ((value['insurerLineItems'] as Array<any>).map(LineItemWithMatchInfoToJSON)),
        'contractorLineItems': ((value['contractorLineItems'] as Array<any>).map(LineItemWithMatchInfoToJSON)),
        'roomMatchGroups': ((value['roomMatchGroups'] as Array<any>).map(RoomMatchGroupWithItemsToJSON)),
        'lineItemMatchGroups': ((value['lineItemMatchGroups'] as Array<any>).map(LineItemMatchGroupWithItemsToJSON)),
    };
}

